import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CharacterSkinComponent } from '../global-map/components/character-slots/character-skin/character-skin.component';
import { CharacterSlotsComponent } from '../global-map/components/character-slots/character-slots.component';

import { SubtitleComponent } from '../main-game/components/game-modals/modal-components/subtitle/subtitle.component';
import { ButtonComponent } from '../main-game/components/game-modals/modal-components/button/button.component';
import { ThousandSuffixesPipe } from './pipes/thousandSuffixes.pipe';
import { ActionModalComponent } from './components/action-modal/action-modal.component';
import { SlotModalSubtitleComponent } from './components/action-modal/modals-slices/subtitle/slot-modal-subtitle.component';
import { OpenSlotComponent } from './components/action-modal/modals/open-slot/open-slot.component';
import { BuildingCityInfoComponent } from './components/action-modal/modals/building-city-info/building-city-info.component';
import { BuildingCityConfirmComponent } from './components/action-modal/modals/building-city-confirm/building-city-confirm.component';
import { CardComponent } from './components/card/card.component';
import { FormsModule } from '@angular/forms';
import { BuyLandInfoComponent } from './components/action-modal/modals/buy-land-info/buy-land-info.component';
import { BuyLandConfirmComponent } from './components/action-modal/modals/buy-land-confirm/buy-land-confirm.component';
import { HiringCharacterComponent } from './components/action-modal/modals/hiring-character/hiring-character.component';
import { ProfileComponent } from './components/profile/profile.component';
import { AdminComponent } from './components/action-modal/modals/admin/admin.component';
import { AcceleratorComponent } from './components/action-modal/modals/accelerator/accelerator.component';
import { ProgressBarHorizontalComponent } from '../main-game/components/game-modals/modal-components/progress-bar-horizontal/progress-bar-horizontal.component';
import { CharacterSelectGridComponent } from './components/action-modal/modals/character-select-grid/character-select-grid.component';
import { ProgressBarWithLevelComponent } from '../main-game/components/game-modals/modal-components/progress-bar-with-level/progress-bar-with-level.component';
import { ProfessionXpBoostinComponent } from './components/action-modal/modals/profession-xp-boostin/profession-xp-boostin.component';
import { EnergyRestoringComponent } from './components/action-modal/modals/energy-restoring/energy-restoring.component';
import { CharacterFrameComponent } from './components/action-modal/modals-slices/character-frame/character-frame.component';
import { CharacterEnergyScaleComponent } from './components/action-modal/modals-slices/character-energy-scale/character-energy-scale.component';
import { RestoreBosstingCardListComponent } from './components/action-modal/modals-slices/restore-bossting-card-list/restore-bossting-card-list.component';
import { SpecialityHolderComponent } from './components/action-modal/modals-slices/speciality-holder/speciality-holder.component';
import { FullValuePopupComponent } from './components/action-modal/modals-slices/full-value-popup/full-value-popup.component';
import { HomeCharacterSelectComponent } from './components/action-modal/modals/home-character-select/home-character-select.component';
import { CharacterSpecialityLevelAndIconComponent } from './components/action-modal/modals-slices/character-speciality-level-and-icon/character-speciality-level-and-icon.component';
import { WelcomeComponent } from './components/action-modal/modals-slices/welcome/welcome.component';
import { TutorialBgComponent } from './components/tutorial-bg/tutorial-bg.component';
import { TutorialTooltipComponent } from './components/action-modal/modals-slices/tutorial-tooltip/tutorial-tooltip.component';
import { TutorialArrowComponent } from './components/action-modal/modals-slices/tutorial-arrow/tutorial-arrow.component';
import { TutorialTextFieldComponent } from './components/action-modal/modals-slices/tutorial-text-field/tutorial-text-field.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { OnlyNumberDirective } from './directive/only-number.directive';
import { PubResultsComponent } from './components/action-modal/modals/pub-results/pub-results.component';
import { ProgressBarComponent } from '../main-game/components/game-modals/modal-components/progress-bar/progress-bar.component';
import { HintsComponent } from './components/hints/hints.component';
import { ClaimCardComponent } from '../main-game/phaser/components/fishing-modal/components/claim-card/claim-card.component';

@NgModule({
  imports: [CommonModule, FormsModule],
  providers: [ThousandSuffixesPipe],
  declarations: [
    CharacterSlotsComponent,
    CharacterSkinComponent,
    ActionModalComponent,
    OpenSlotComponent,
    SubtitleComponent,
    SlotModalSubtitleComponent,
    ButtonComponent,
    ThousandSuffixesPipe,
    BuildingCityInfoComponent,
    BuildingCityConfirmComponent,
    CardComponent,
    BuyLandInfoComponent,
    BuyLandConfirmComponent,
    HiringCharacterComponent,
    ProfileComponent,
    AdminComponent,
    AcceleratorComponent,
    ProgressBarHorizontalComponent,
    CharacterSelectGridComponent,
    ProgressBarWithLevelComponent,
    ProfessionXpBoostinComponent,
    EnergyRestoringComponent,
    CharacterFrameComponent,
    ClaimCardComponent,
    CharacterEnergyScaleComponent,
    RestoreBosstingCardListComponent,
    SpecialityHolderComponent,
    FullValuePopupComponent,
    HomeCharacterSelectComponent,
    CharacterSpecialityLevelAndIconComponent,
    WelcomeComponent,
    TutorialBgComponent,
    TutorialTooltipComponent,
    TutorialArrowComponent,
    TutorialTextFieldComponent,
    PageNotFoundComponent,
    OnlyNumberDirective,
    PubResultsComponent,
    ProgressBarComponent,
    HintsComponent,
  ],
  exports: [
    CharacterSlotsComponent,
    CharacterSkinComponent,
    CharacterSelectGridComponent,
    ActionModalComponent,
    SubtitleComponent,
    SlotModalSubtitleComponent,
    ButtonComponent,
    ThousandSuffixesPipe,
    ProfileComponent,
    ProgressBarHorizontalComponent,
    ProgressBarWithLevelComponent,
    CharacterFrameComponent,
    CharacterEnergyScaleComponent,
    CharacterSpecialityLevelAndIconComponent,
    FullValuePopupComponent,
    CardComponent,
    TutorialBgComponent,
    TutorialTooltipComponent,
    TutorialTextFieldComponent,
    TutorialArrowComponent,
    PageNotFoundComponent,
    ProgressBarComponent,
    HintsComponent,
    ClaimCardComponent,
  ],
})
export class SharedComponentsModule {}
